export const StudentRole = "Student";
export const MentorRole = "Mentor";
export const CoordinatorRole = "Coordinator";
export const RoleMap = {
  Student: StudentRole,
  Mentor: MentorRole,
  Coordinator: CoordinatorRole
};

export const SemesterSelectOptions = ["Spring", "Fall"].map(x => {
  return { value: x, text: x };
});

export const MonthsSelectOptions = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
].map((x, idx) => {
  return { value: idx + "", text: x };
});
